<template>
  <v-container fluid grid-list-md v-loading="isLoadingGeneral">
    <dps-subheader @on-dates-selected="onDatesSelected" :is-loading="isLoadingGeneral"></dps-subheader>

    <v-layout row wrap>
      <v-flex xs12 md3 sm6 v-for="box in boxes" :key="box.title">
        <info-dashboard-box
          :title="box.title"
          :mask-title="box.maskTitle"
          :big-text-value="box.bigTextValue"
          :small-text-value="box.smallTextValue"
          :box-class="box.boxClass"
          :title-class="box.titleClass"
          :class-icon="box.classIcon"
        ></info-dashboard-box>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex sm12 md6 class="spacing-top">
        <income-graph-box ref="incomeGraphBox"></income-graph-box>
      </v-flex>
      <v-flex sm12 md6 class="spacing-top">
        <booking-graph-box ref="bookingGraphBox"></booking-graph-box>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 md12 sm12>
        <briefing-parking-list class="spacing-top" ref="briefingParkingList"></briefing-parking-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import InfoDashboardBox from '@/components/commons/InfoDashboardBox.vue';
import Subheader from '@/components/commons/Subheader.vue';
import statisticService from '@/services/statisticService';
import IncomeGraphBox from '@/components/commons/IncomeGraphBox.vue';
import BookingGraphBox from '@/components/commons/BookingGraphBox.vue';
import BriefingParkingList from '@/components/commons/BriefingParkingList.vue';
import store from '@/store';
import moment from 'moment';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'Dashboard',
  components: {
    [InfoDashboardBox.name]: InfoDashboardBox,
    [Subheader.name]: Subheader,
    [IncomeGraphBox.name]: IncomeGraphBox,
    [BookingGraphBox.name]: BookingGraphBox,
    [BriefingParkingList.name]: BriefingParkingList
  },
  data() {
    return {
      dates: [],
      boxes: [
        {
          title: 'private_dash_incomes_title',
          boxClass: 'light-green',
          titleClass: 'success',
          classIcon: 'fa fa-eur',
          bigTextValue: '- €',
          smallTextValue: '- €'
        },
        {
          title: 'private_dash_bookings_title',
          boxClass: 'cyan',
          titleClass: 'info',
          classIcon: 'fa fa-users',
          bigTextValue: '-',
          smallTextValue: '-'
        },
        {
          title: 'private_dash_subscriptions_title',
          boxClass: 'amber lighten-1',
          titleClass: 'warning',
          classIcon: 'fa fa-users',
          bigTextValue: '-',
          smallTextValue: '-'
        },
        {
          title: 'private_dash_tenants_title',
          boxClass: 'grey lighten-1',
          titleClass: 'gray',
          classIcon: 'fa fa-users',
          bigTextValue: '-',
          smallTextValue: '-'
        }
      ],
      isLoading: false,
      isLoadingIncome: false,
      isLoadingBooking: false,
      isLoadingGeneral: false
    };
  },
  created() {
    store.commit('UPDATE_PARKING_SELECTED', null);

    EventBus.$on(keys.eventOnIncomeGraphDone, this.onIncomeGraphDone);
    EventBus.$on(keys.eventOnBookingGraphDone, this.onBookingGraphDone);
    EventBus.$on(keys.eventOnLanguageChanged, this.updateBoxes);
  },
  destroyed() {
    EventBus.$on(keys.eventOnIncomeGraphDone, this.onIncomeGraphDone);
    EventBus.$on(keys.eventOnBookingGraphDone, this.onBookingGraphDone);
  },
  methods: {
    onIncomeGraphDone() {
      this.isLoadingIncome = false;
      this.isLoadingGeneral = this.isLoading || this.isLoadingIncome || this.isLoadingBooking;
    },
    onBookingGraphDone() {
      this.isLoadingBooking = false;
      this.isLoadingGeneral = this.isLoading || this.isLoadingIncome || this.isLoadingBooking;
    },
    updateBoxes() {
      let paramsDashboard = {
        start: moment(this.dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(this.dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      };

      statisticService.dashboard(paramsDashboard, this.onLoadBoxes, this.errorOnLoadBoxes);
    },
    onDatesSelected(params) {
      this.isLoadingGeneral = true;
      this.isLoading = true;
      this.isLoadingIncome = true;
      this.isLoadingBooking = true;

      if (typeof this.$refs.incomeGraphBox === 'undefined') {
        setTimeout(() => {
          this.updateCharts(params);
        }, 500);
      } else {
        this.updateCharts(params);
      }
    },
    updateCharts(params) {
      if (typeof this.$refs.incomeGraphBox === 'undefined') {
        setTimeout(() => {
          this.updateCharts(params);
        }, 500);
        return;
      }
      this.dates = params.dates;

      this.$refs.incomeGraphBox.updateEarnings(this.dates);
      this.$refs.bookingGraphBox.updateBookings(this.dates);
      this.$refs.briefingParkingList.updateRankings(this.dates);

      this.updateBoxes();
    },
    onLoadBoxes(data) {
      this.isLoading = false;
      this.isLoadingGeneral = this.isLoading || this.isLoadingAvaialability || this.isLoadingBooking;

      if (typeof data.earnings === 'undefined') {
        return;
      }

      let localeIso = store.state.user.manager.localeIso;
      this.boxes = [
        {
          title: 'private_dash_incomes_title',
          boxClass: 'light-green',
          titleClass: 'success',
          classIcon: store.state.countryConstantsSelected.icon,
          bigTextValue: data.earnings.monthly,
          smallTextValue: data.earnings.current
        },
        {
          title: 'private_dash_bookings_title',
          boxClass: 'cyan',
          titleClass: 'info',
          classIcon: 'fa fa-users',
          bigTextValue: data.bookings.monthly.toLocaleString(localeIso),
          smallTextValue: data.bookings.current
        },
        {
          title: 'private_dash_subscriptions_title',
          boxClass: 'amber lighten-1',
          titleClass: 'warning',
          classIcon: 'fa fa-users',
          bigTextValue: data.subscriptions.monthly.toLocaleString(localeIso),
          smallTextValue: data.subscriptions.current
        },
        {
          title: 'private_dash_tenants_title',
          boxClass: 'grey lighten-1',
          titleClass: 'gray',
          classIcon: 'fa fa-users',
          bigTextValue: data.tenants.amount.toLocaleString(localeIso),
          smallTextValue: ''
        }
      ];
    },
    errorOnLoadBoxes() {}
  }
};
</script>

<style lang="scss" scoped>
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue